const SignUpButton = (props) => {
	return (
		<div className="rounded-2xl h-fit w-fit pl-4 pr-4 pt-2 pb-2 bg-white text-fuzerPurp text-xl font-extrabold cursor-pointer select-none hover:opacity-[85%]" {...props}>
			Sign up
		</div>
	)
}

export default SignUpButton